import { enhanceFormFieldDataWithTypes, toPaginate } from '@/utils/infrastructure';
import { CoreEnums } from '@/utils/domain/constants';
import _, { merge } from 'lodash';
import { getIntl } from 'umi';
import { bindServices } from '@/services/api';

const api = bindServices('users');

import {
  queryAddEnviroments,
  queryAddUserGroupUser,
  queryBulkAction,
  queryConfirmAccount,
  queryGetEnvironmentsConfig,
  queryResetPassword,
  querySendAccountConfirmationEmail,
  querySendRecoveryPasswordEmail,
  queryUnlockAccount,
  queryUserActivate,
  queryUserGroupUsers,
} from './service';

const { BulkActionType } = CoreEnums;

import { toImportExcel } from '@/services/global';
import environmentConfig from './components/AddOnEnvironment/_form';
import { filtersConfig } from './utils';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'users',

  state: {
    newUserGroup: false,
    newUserOnGroup: false,
    newUserOnEnvironment: false,
    newUser: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    userGroups: [],
    pagination: { ...meta },
    select: 'id,fullName,isActive,email,role,userId,extraData',
    notSelectSearch: 'userId,extraData',
    expand: {
      position: { select: 'name' },
      area: { select: 'name' },
    },
    filtersConfig,
    paramsView: {
      select:
        'id,email,accessType,created,creator,isActive,lastNames,mobilePhone,names,role,updated,modifier',
      expand: {
        position: { select: 'name' },
        userBoss: { select: 'fullName' },
        user: {
          select: 'twoFactorEnabled',
        },
        area: { select: 'name' },
      },
    },
    paramsEdit: {
      select:
        'id,email,accessType,isActive,lastNames,mobilePhone,names,positionId,role,updated,userBossId,extraData,areaId',
      expand: {
        position: { select: 'id,name' },
        area: { select: 'id,name' },
        userBoss: { select: 'id,fullName' },
        user: {
          select: 'twoFactorEnabled',
        },
      },
    },

    view: false,
    orderBy: 'fullName asc',
    isConfig: false,
    userEnvironments: [],
    idSelected: null,
    openResetPasswordModal: false,
    showImport: false,
    bulkActionErrors: null,
    bulkActionErrorMessage: null,
    showBulkActionErrors: false,
    bulkActionErrorType: 'delete', // 'delete' o 'import'
  },

  effects: {
    *fetchList({ payload }, { call, put, select }) {
      try {
        const response = yield call(api.getAll, {
          route: 'user/paged',
          params: payload,
        });

        // Only load extraFields if they are not already loaded
        const currentState = yield select((state) => state.users);
        let extraFields = currentState.extraFields;

        if (!extraFields || extraFields.length === 0) {
          const responseExtraFields = yield call(api.getAll, {
            route: 'userExtraField',
            params: {
              orderBy: 'order asc, displayText asc',
            },
          });
          extraFields = responseExtraFields;
        }

        yield put({
          type: 'queryUsers',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
            extraFields: extraFields,
          },
        });
      } catch (e) {
        // Re-throw the error so dva's automatic loading works correctly
        throw e;
      }
    },

    // Effect to load extra fields independently
    // Useful to reload only extraFields without affecting the user list
    // Currently not used, but kept for future needs
    // *fetchExtraFields({ payload }, { call, put }) {
    //   try {
    //     const responseExtraFields = yield call(queryExtraFields, {
    //       orderBy: 'order asc, displayText asc',
    //     });
    //
    //     yield put({
    //       type: 'setExtraFields',
    //       payload: responseExtraFields,
    //     });
    //   } catch (e) {}
    // },

    *addNewUserGroup({ payload }, { put }) {
      yield put({ type: 'addUserGroup', payload });
    },

    *addNewUserOnGroup({ payload }, { put }) {
      yield put({ type: 'addUserOnGroup', payload });
    },

    *addNewUserOnEnvironment({ payload }, { put }) {
      yield put({ type: 'addUserOnEnvironment', payload });
    },

    *fetchUserOnGroup({ payload }, { call, put }) {
      try {
        const response = yield call(queryUserGroupUsers, payload);
        yield put({ type: 'listUserOnGroup', response });
      } catch (error) {
        // Re-throw the error so dva's automatic loading works correctly
        throw error;
      }
    },

    *hideNewUserOnGroup({ payload = 'hideUserOnGroup' }, { put }) {
      yield put({ type: payload });
    },

    *hideNewUserOnEnvironment({ payload = 'hideUserOnEnvironment' }, { put }) {
      yield put({ type: payload });
    },

    *onCloseUserOnGroup(_a, { put }) {
      yield put({ type: 'closeUserOnGroup' });
    },

    *onCloseUserOnEnvironment(_a, { put }) {
      yield put({ type: 'closeUserOnEnvironment' });
    },

    *addUserGroupUser({ payload }, { put }) {
      yield put({ type: 'addUserGroupList', payload });
    },

    *saveUserGroupUsers({ payload }, { call, put }) {
      try {
        yield call(queryAddUserGroupUser, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({
          type: 'closeUserOnGroup',
        });
        // Manually reset userGroupId field cache after closing
        yield put({
          type: 'global/resetApiData',
          payload: ['userGroupId'],
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *closeAllFormUser({ payload }, { put }) {
      yield put({ type: 'closeFormUser', payload });
    },

    *addNewUser({ payload }, { put }) {
      yield put({ type: 'addUser', payload });
      if (!_.isNil(payload.id)) {
        yield put({ type: 'editOrViewUser', payload });
      }
    },

    *search({ payload }, { put }) {
      yield put({ type: 'global/tableSearchState', payload });
    },

    *editItemUser({ payload }, { call, put, select }) {
      try {
        const response = yield call(api.getById, {
          route: 'user',
          id: payload.id,
          params: payload.params,
        });

        // Ensure extraFields are loaded
        const currentState = yield select((state) => state.users);
        let extraFields = currentState.extraFields;

        if (!extraFields || extraFields.length === 0) {
          const responseExtraFields = yield call(api.getAll, {
            route: 'userExtraField',
            params: {
              orderBy: 'order asc, displayText asc',
            },
          });
          extraFields = responseExtraFields;

          // Update extraFields in state
          yield put({
            type: 'setExtraFields',
            payload: extraFields,
          });
        }

        yield put({
          type: 'editUser',
          payload: { ...payload, item: response },
        });
      } catch (error) {
        // Re-throw the error so dva's automatic loading works correctly
        throw error;
      }
    },

    *saveNewUser({ payload }, { call, put }) {
      try {
        yield call(api.create, {
          route: 'user',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });

        yield put({ type: 'saveUser' });
        yield put({ type: 'fetchList', payload: payload.params });
      } catch (error) {
        if (error.message) {
          return yield put({
            type: 'global/showNotificationsForm',
            payload: { visible: true, type: 'error', message: error.message },
            validationErrors: error.validationErrors,
          });
        }

        yield put({
          type: 'global/showNotificationsForm',
          payload: { visible: true, type: 'error' },
        });
      }
    },

    *saveEditUser({ payload }, { call, put }) {
      try {
        yield call(api.update, {
          route: 'user',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });

        yield put({ type: 'saveUser' });
        yield put({ type: 'fetchList', payload: payload.params });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({ type: `global/modalConfirm`, state: false, id: null });
        const response = yield call(api.apiRoute, {
          route: `user/${id}`,
          method: 'delete',
        });
        yield put({ type: 'deleteUser', payload: response });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'fetchList', payload: params });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *deleteItemUserGroup({ id }, { put }) {
      yield put({ type: 'deleteUserGroup', payload: id });
      yield put({ type: `global/modalConfirm`, state: false, id: null });
    },

    *editActive({ payload }, { call, put }) {
      try {
        yield call(queryUserActivate, payload.id, payload.state);
        yield put({ type: 'userActive', payload });
      } catch (e) {
        // Re-throw the error so dva's automatic loading works correctly
        throw e;
      }
    },

    *bulkActivateUsers({ payload }, { call, put }) {
      try {
        yield call(queryBulkAction, BulkActionType.Activate, payload.userIds);
        yield put({ type: 'bulkUserActive', payload: { userIds: payload.userIds, state: true } });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *bulkDeactivateUsers({ payload }, { call, put }) {
      try {
        yield call(queryBulkAction, BulkActionType.Deactivate, payload.userIds);
        yield put({ type: 'bulkUserActive', payload: { userIds: payload.userIds, state: false } });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *bulkDeleteUsers({ payload }, { call, put, select }) {
      try {
        // Get current user list to be able to map IDs to names
        const currentState = yield select((state) => state.users);
        const usersList = currentState.list || [];

        const response = yield call(queryBulkAction, BulkActionType.Delete, payload.userIds);

        // Handle BulkActionResponse
        if (response.type === 3 && response.requested > 0) {
          // type 3 = Delete
          const { requested, errors } = response;
          const successCount = requested - errors.length;

          if (errors.length > 0) {
            // There are errors - show drawer with details
            const intl = getIntl();

            let errorMessage;
            if (successCount > 0) {
              // There are successfully deleted elements and errors
              const eliminated = intl.formatMessage({
                id:
                  successCount === 1
                    ? 'global.bulk.delete.eliminated.singular'
                    : 'global.bulk.delete.eliminated.plural',
              });
              const successElement = intl.formatMessage({
                id:
                  successCount === 1
                    ? 'global.bulk.delete.element.singular'
                    : 'global.bulk.delete.element.plural',
              });
              const totalElement = intl.formatMessage({
                id:
                  requested === 1
                    ? 'global.bulk.delete.element.singular'
                    : 'global.bulk.delete.element.plural',
              });
              const errorElement = intl.formatMessage({
                id:
                  errors.length === 1
                    ? 'global.bulk.delete.element.singular'
                    : 'global.bulk.delete.element.plural',
              });
              const couldNotBeDeleted = intl.formatMessage({
                id:
                  errors.length === 1
                    ? 'global.bulk.delete.could.not.be.deleted.singular'
                    : 'global.bulk.delete.could.not.be.deleted.plural',
              });

              errorMessage = intl.formatMessage(
                { id: 'global.bulk.delete.success' },
                {
                  eliminated,
                  successCount,
                  successElement,
                  total: requested,
                  totalElement,
                  errorCount: errors.length,
                  errorElement,
                  couldNotBeDeleted,
                },
              );
            } else {
              // Only errors, no elements deleted
              const errorElement = intl.formatMessage({
                id:
                  errors.length === 1
                    ? 'global.bulk.delete.element.singular'
                    : 'global.bulk.delete.element.plural',
              });
              const couldNotBeDeleted = intl.formatMessage({
                id:
                  errors.length === 1
                    ? 'global.bulk.delete.could.not.be.deleted.singular'
                    : 'global.bulk.delete.could.not.be.deleted.plural',
              });

              errorMessage = intl.formatMessage(
                { id: 'global.bulk.delete.error.only' },
                {
                  errorCount: errors.length,
                  errorElement,
                  couldNotBeDeleted,
                },
              );
            }

            // Delete only users that had no errors
            const errorIds = errors.map((error) => error.id);
            const successfulUserIds = payload.userIds.filter((id) => !errorIds.includes(id));

            // Only remove from list if there were successful users
            if (successfulUserIds.length > 0) {
              yield put({ type: 'bulkUserDelete', payload: { userIds: successfulUserIds } });
            }

            // Map errors with user names
            const errorsWithUserNames = errors.map((error) => {
              const user = usersList.find((u) => u.id === error.id);
              return {
                id: error.id,
                userName: user
                  ? user.fullName || user.names || `Usuario ${error.id}`
                  : `Usuario ${error.id}`,
                errorMessage: error.errorMessage,
              };
            });

            yield put({
              type: 'setBulkActionErrors',
              payload: {
                errorData: {
                  errorMessage,
                  errors: errorsWithUserNames,
                  errorType: 'delete',
                },
              },
            });

            // Automatically open the errors drawer
            yield put({
              type: 'toggleBulkActionErrorsDrawer',
              payload: { open: true },
            });
          } else {
            // Everything successful
            yield put({ type: 'bulkUserDelete', payload: { userIds: payload.userIds } });
            yield put({
              type: 'global/showNotificationsGlobal',
              payload: { visible: true, type: 'success' },
            });
          }
        }
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *setOrderBy({ payload }, { put }) {
      yield put({ type: 'orderBy', payload });
    },

    *eventSorterUserGroup({ payload }, { put }) {
      yield put({ type: 'sorterUserGroup', payload });
    },

    *closeForms({ payload = 'closeForm' }, { put }) {
      yield put({ type: payload });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },

    *fetchUserOnEnvironment({ payload }, { call, put }) {
      try {
        const response = yield call(queryGetEnvironmentsConfig, payload);
        yield put({ type: 'listUserOnEnvironment', response });
      } catch (error) {
        // Re-throw the error so dva's automatic loading works correctly
        throw error;
      }
    },

    *openModalConfig({ payload }, { call, put }) {
      try {
        const response = yield call(queryGetEnvironmentsConfig, {
          params: payload.params,
          userId: payload.id,
        });
        yield put({
          type: 'queryGetConfig',
          payload: {
            idSelected: payload.id,
            data: response,
            form: environmentConfig.environmentForm,
          },
        });
      } catch (error) {
        // Re-throw the error so dva's automatic loading works correctly
        throw error;
      }
    },

    *addListEnviroment({ payload }, { put }) {
      yield put({ type: 'addEnviromentToList', payload });
    },

    *deleteEnviromentFromList({ payload }, { put }) {
      yield put({ type: 'removeEnviromentToList', payload });
      yield put({ type: `global/modalConfirmDrawer`, state: false, id: null });
    },

    *saveNewListEnviroments({ payload }, { call, put }) {
      try {
        yield call(queryAddEnviroments, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({
          type: 'closeUserOnEnvironment',
        });
        // Manually reset enviromentId field cache after closing
        yield put({
          type: 'global/resetApiData',
          payload: ['enviromentId'],
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *fetchImport({ payload }, { call, put, select }) {
      try {
        const { file, isDeleteData } = payload;

        // Get current state to maintain filters, pagination, etc.
        const currentState = yield select((state) => state);
        const { global, users } = currentState;
        const { searchCriteria, isActive, pageSize, globalFilters } = global;
        const { pagination, orderBy, expand, select: selectFields, notSelectSearch } = users;

        const res = yield call(toImportExcel, {
          route: 'user',
          fileContent: file,
          deleteExistingData: isDeleteData,
        });

        if (res.errorMessage) {
          const intl = getIntl();

          // Process all import errors to display in drawer
          const importErrors = [];

          if (res.errors && res.errors.length > 0) {
            res.errors.forEach((errorRow) => {
              if (errorRow.errors && errorRow.errors.length > 0) {
                errorRow.errors.forEach((error) => {
                  importErrors.push({
                    id: `${errorRow.rowNumber}-${error.columnName || 'unknown'}`, // Unique ID for each error
                    rowNumber: `${intl.formatMessage({ id: 'global.text.row' })} ${
                      errorRow.rowNumber
                    }`,
                    columnName: error.columnName || '',
                    errorMessage: error.errorMessage,
                  });
                });
              }
            });
          }

          // General error message
          const errorCount = importErrors.length;
          const rowsWithErrors = res.errors ? res.errors.length : 0;

          const errorMessage = intl.formatMessage(
            { id: 'global.error.import.detailed' },
            {
              errorCount,
              rowsWithErrors,
              originalMessage: res.errorMessage || '',
            },
          );

          // Use the same drawer system as for bulk deletion
          yield put({
            type: 'setBulkActionErrors',
            payload: {
              errorData: {
                errorMessage,
                originalErrorMessage: res.errorMessage, // Original backend message for title
                errors: importErrors,
                errorType: 'import',
              },
            },
          });

          // Automatically open the errors drawer
          yield put({
            type: 'toggleBulkActionErrorsDrawer',
            payload: { open: true },
          });

          // Close the import modal
          yield put({ type: 'queryImport', payload: { ...res } });
        } else {
          yield put({ type: 'queryImport', payload: { ...res } });

          // Build parameters maintaining current state (same as getParams in component)
          const { getFiltersGlobalFilters } = yield import('@/utils/infrastructure');
          const { filtersConfig } = yield import('./utils');

          // Map globalFilters to use oDataField when available
          const mappedGlobalFilters = _.mapKeys(globalFilters, (value, key) => {
            const filterConfig = filtersConfig.find((filter) => filter.name === key);
            return filterConfig?.oDataField || key;
          });

          const globalFiltersStr = getFiltersGlobalFilters(mappedGlobalFilters);

          // Combine isActive with globalFilters
          let combinedFilter = null;
          if (isActive && globalFiltersStr) {
            combinedFilter = `${isActive} and ${globalFiltersStr}`;
          } else if (isActive) {
            combinedFilter = isActive;
          } else if (globalFiltersStr) {
            combinedFilter = globalFiltersStr;
          }

          const refreshParams = {
            ...pagination,
            ...(pageSize && { page: pagination.page, limit: pageSize }),
            ...(searchCriteria && { search: searchCriteria }),
            ...(notSelectSearch && { notSelectSearch }),
            ...(combinedFilter && { filter: combinedFilter }),
            ...(orderBy && { orderBy }),
            ...(expand && { expand }),
            ...(selectFields && { select: selectFields }),
          };

          yield put({ type: 'fetchList', payload: refreshParams });
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: true,
              type: 'success',
            },
          });
        }
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },

    *closeForm({ payload }, { put }) {
      yield put({
        type: 'closeFormReducer',
        payload,
      });
    },

    *sendAccountConfirmationEmail({ payload }, { call, put }) {
      try {
        yield call(querySendAccountConfirmationEmail, payload.id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotificationsGlobal`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: false,
            },
          });
        }
      }
    },

    *confirmAccount({ payload }, { call, put }) {
      try {
        yield call(queryConfirmAccount, payload.id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotificationsGlobal`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: false,
            },
          });
        }
      }
    },

    *sendRecoveryPasswordEmail({ payload }, { call, put }) {
      try {
        yield call(querySendRecoveryPasswordEmail, payload.id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotificationsGlobal`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: false,
            },
          });
        }
      }
    },

    *unlockAccount({ payload }, { call, put }) {
      try {
        yield call(queryUnlockAccount, payload.id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotificationsGlobal`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: false,
            },
          });
        }
      }
    },

    *toggleResetPasswordModal({ payload }, { put }) {
      yield put({
        type: 'queryToggleResetPasswordModal',
        payload,
      });
    },

    *resetPassword({ payload }, { call, put }) {
      try {
        yield call(queryResetPassword, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'queryToggleResetPasswordModal',
          payload: {
            open: false,
            id: null,
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotificationsGlobal`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: false,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *toggleImportComponent({ payload }, { put }) {
      yield put({
        type: 'queryToggleImportComponent',
        payload: { showImport: payload.show },
      });
    },

    *toggleBulkActionErrorsDrawer({ payload }, { put }) {
      yield put({
        type: 'queryToggleBulkActionErrorsDrawer',
        payload,
      });
    },

    *clearBulkActionErrors({ payload }, { put }) {
      yield put({
        type: 'queryClearBulkActionErrors',
      });
    },
  },

  reducers: {
    queryGetConfig(state, { payload }) {
      return {
        ...state,
        isConfig: true,
        newUserOnGroup: false,
        idSelected: payload.idSelected,
        formConfig: payload.form,
        userEnvironments: payload.data.map((item) => ({
          id: item.environment.id,
          name: item.environment.name,
        })),
      };
    },
    hideConfig(state) {
      return {
        ...state,
        selectedItem: null,
        processConfigList: [],
        userEnvironments: [],
        isConfig: false,
        formConfig: null,
      };
    },
    addEnviromentToList(state, { payload }) {
      return {
        ...state,
        userEnvironments: [...state.userEnvironments, payload],
      };
    },
    removeEnviromentToList(state, { payload }) {
      return {
        ...state,
        userEnvironments: state.userEnvironments.filter((item) => item.id !== payload),
      };
    },

    queryUsers(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: merge(state.pagination, toPaginate(payload)),
        extraFields: payload.extraFields,
      };
    },

    setExtraFields(state, { payload }) {
      return {
        ...state,
        extraFields: payload,
      };
    },

    addUserGroup(state, { payload }) {
      return {
        ...state,
        newUserGroup: payload.state,
        selectedItem: payload.item,
        view: payload.view,
      };
    },

    addUserOnGroup(state, { payload }) {
      return {
        ...state,
        newUserOnGroup: payload.state,
        selectedItem: payload.item,
        formConfig: payload.form,
      };
    },

    addUserOnEnvironment(state, { payload }) {
      return {
        ...state,
        newUserOnEnvironment: payload.state,
        selectedItem: payload.item,
        formConfig: payload.form,
      };
    },

    sorterUserGroup(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideUserOnGroup(state) {
      return {
        ...state,
        selectedItem: null,
        userGroups: [],
        formConfig: null,
      };
    },

    hideUserOnEnvironment(state) {
      return {
        ...state,
        selectedItem: null,
        userEnvironments: [],
        formConfig: null,
      };
    },

    closeUserOnGroup(state) {
      return {
        ...state,
        newUserOnGroup: false,
      };
    },

    closeUserOnEnvironment(state) {
      return {
        ...state,
        newUserOnEnvironment: false,
      };
    },

    listUserOnGroup(state, { response }) {
      return {
        ...state,
        userGroups: response.map((item) => {
          return {
            id: item.id,
            group: item.name,
          };
        }),
      };
    },

    listUserOnEnvironment(state, { response }) {
      return {
        ...state,
        userEnvironments: response.map((item) => {
          return {
            id: item.id,
            name: item.name,
          };
        }),
      };
    },

    addUserGroupList(state, { payload }) {
      return {
        ...state,
        userGroups: [...state.userGroups, payload],
      };
    },

    addUser(state, { payload }) {
      return {
        ...state,
        newUser: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    editOrViewUser(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editUser(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    closeFormUser(state) {
      return {
        ...state,
        newUser: false,
        selectedItem: null,
      };
    },

    saveUser(state) {
      return {
        ...state,
        newUser: false,
        selectedItem: null,
        id: null,
      };
    },

    deleteUser(state) {
      return {
        ...state,
      };
    },

    deleteUserGroup(state, { payload }) {
      return {
        ...state,
        userGroups: state.userGroups.filter((item) => item.id !== payload),
      };
    },

    userActive(state, { payload }) {
      return {
        ...state,
        list: _.map(state.list, (o) => {
          if (o.id === payload.id) {
            _.set(o, 'isActive', payload.state);
          }
          return o;
        }),
      };
    },

    bulkUserActive(state, { payload }) {
      return {
        ...state,
        list: _.map(state.list, (o) => {
          if (payload.userIds.includes(o.id)) {
            _.set(o, 'isActive', payload.state);
          }
          return o;
        }),
      };
    },

    bulkUserDelete(state, { payload }) {
      return {
        ...state,
        list: state.list.filter((o) => !payload.userIds.includes(o.id)),
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newUserGroup: false,
        newUserOnGroup: false,
        newUserOnEnvironment: false,
        newUser: false,
        selectedItem: null,
        view: false,
        extraFields: [], // Clear extraFields when leaving the section
      };
    },

    queryToggleImportComponent(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    queryImport(state) {
      return {
        ...state,
        showImport: false,
      };
    },

    queryToggleResetPasswordModal(state, { payload }) {
      return {
        ...state,
        openResetPasswordModal: payload.open,
        idSelected: payload.id,
      };
    },

    setBulkActionErrors(state, { payload }) {
      return {
        ...state,
        bulkActionErrorData: payload.errorData,
        showBulkActionErrors: true,
      };
    },

    queryToggleBulkActionErrorsDrawer(state, { payload }) {
      return {
        ...state,
        showBulkActionErrors: payload.open,
      };
    },

    queryClearBulkActionErrors(state) {
      return {
        ...state,
        bulkActionErrorData: null,
        showBulkActionErrors: false,
      };
    },
  },
};

export default Model;
